import logo from "../../logo.svg";
import heroBanner01 from "../../assets/hero-banner-slider-01.jpg";
import Auction_Image from "../../assets/auction-card-img-01.png";
import Start_a_bid_img from "../../assets/start-bit-img.png";
import Header_Logo from "../../assets/header-logo.png";
import envelop from "../../assets/envelop.png";
import Customer_support from "../../assets/Customer-support.png";
import language from "../../assets/language.png";
import search from "../../assets/search.png";
import account from "../../assets/account.png";
import down_arrow from "../../assets/down-arrow.png";
import car_bg_banner from "../../assets/car-bg-banner.jpg";
import car_bg_img from "../../assets/car-bg-img-bg.png";
import bmw from "../../assets/bmw.png";
import Chevrolet from "../../assets/Chevrolet.png";
import ford from "../../assets/ford.png";
import Ferrari from "../../assets/Ferrari.png";
import hyundai from "../../assets/hyundai.png";
import honda from "../../assets/honda.png";
import step_images from "../../assets/step-images.png";
import step_images_01 from "../../assets/step-img-01.png";
import step_images_02 from "../../assets/step-img-02.png";
import step_images_03 from "../../assets/step-img-03.png";
import curve_arrow_dowm_top from "../../assets/curve-arrow-dowm-top.png";
import curve_arrow_top_down from "../../assets/curve-arrow-top-down.png";
import step_top_img from "../../assets/step-top-img.png";
import download_sec_bg_img from "../../assets/download-sec-bg-img.jpg";
import download_img_mobile from "../../assets/download_img_mobile.png";
import download_img_car from "../../assets/download_img_car.png";
import google_play from "../../assets/google_play.png";
import app_store from "../../assets/app_store.png";
import email_img from "../../assets/email-img.png";
import footer_top_girl from "../../assets/footer-top-girl-img.png";
import footer_top_arrow from "../../assets/footer-top-arrow.png";
import payment_img from "../../assets/payment_img.png";
import footer_bg from "../../assets/footer-bg.jpg";
import ContactUsBannerbg from "../../assets/ContactUsBannerbg.jpg";
import CategoryBannerBg from "../../assets/CategoryBannerBg.jpg";
import SellWithUsBannerBg from "../../assets/SellWithUsBannerBg.jpg";
import HotItWorks_Img_01 from "../../assets/HotItWorks_Img_01.png";
import HotItWorks_Img_02 from "../../assets/HotItWorks_Img_02.png";
import HotItWorks_Img_03 from "../../assets/HotItWorks_Img_03.png";
import HowToBid_Banner_Bg from "../../assets/HowToBid_Banner_Bg.jpg";
import Auction_bg from "../../assets/Auction_bg.jpg";
import payment_card_img from "../../assets/payment_card_img.png";
import log_img from "../../assets/log_img.png";
import lot_overview_img from "../../assets/lot_overview_img.png";
import lot_overview_flag from "../../assets/lot_overview_flag.png";
import seller_profile_img from "../../assets/seller_profile_img.png";
import Seller_Banner from "../../assets/Seller_Banner.jpg";
import seller_profile_bg_01 from "../../assets/seller_profile_bg_01.jpg";
import seller_profile_img_01 from "../../assets/seller_profile_img_01.png";

export const IMAGES = {
  logo: logo,
  heroBanner01: heroBanner01,
  Auction_Image: Auction_Image,
  Start_a_bid_img: Start_a_bid_img,
  Header_Logo: Header_Logo,
  envelop: envelop,
  Customer_support: Customer_support,
  language: language,
  search: search,
  account: account,
  down_arrow: down_arrow,
  car_bg_banner: car_bg_banner,
  car_bg_img: car_bg_img,
  bmw: bmw,
  Chevrolet: Chevrolet,
  Ferrari: Ferrari,
  ford: ford,
  honda: honda,
  hyundai: hyundai,
  step_images: step_images,
  step_images_01: step_images_01,
  step_images_02: step_images_02,
  step_images_03: step_images_03,
  curve_arrow_dowm_top: curve_arrow_dowm_top,
  curve_arrow_top_down: curve_arrow_top_down,
  step_top_img: step_top_img,
  download_sec_bg_img: download_sec_bg_img,
  download_img_mobile: download_img_mobile,
  download_img_car : download_img_car,
  google_play : google_play,
  app_store : app_store,
  email_img : email_img,
  footer_top_girl : footer_top_girl,
  footer_top_arrow : footer_top_arrow,
  payment_img : payment_img,
  footer_bg : footer_bg, 
  ContactUsBannerbg : ContactUsBannerbg,
  CategoryBannerBg : CategoryBannerBg,
  SellWithUsBannerBg : SellWithUsBannerBg,
  HotItWorks_Img_01 : HotItWorks_Img_01,  
  HotItWorks_Img_02 : HotItWorks_Img_02,  
  HotItWorks_Img_03 : HotItWorks_Img_03,
  HowToBid_Banner_Bg : HowToBid_Banner_Bg ,
  Auction_bg : Auction_bg ,   
  payment_card_img : payment_card_img, 
  log_img : log_img, 
  lot_overview_img : lot_overview_img, 
  lot_overview_flag : lot_overview_flag , 
  seller_profile_img : seller_profile_img,
  Seller_Banner : Seller_Banner,
  seller_profile_bg_01 : seller_profile_bg_01,
  seller_profile_img_01 : seller_profile_img_01,    
};
